<div
  tabindex="0"
  class="eb-dropdown"
  [ngClass]="{ 'eb-dropdown--expanded': (expanded$ | async) }"
  (blur)="onBlur()"
>
  <div class="eb-dropdown__trigger" (click)="onClick()">
    <ng-content select="[trigger]"></ng-content>
  </div>
  <div
    class="eb-dropdown__content"
    [class]="'eb-dropdown__content--' + (alignmentClassname$ | async)"
  >
    <ng-content select="[content]"></ng-content>
  </div>
</div>
